export default "__VITE_ASSET__9ea55318__"